// https://www.freakyjolly.com/react-charts-examples/

import React from "react";
import { ResponsiveContainer, AreaChart, Area, YAxis, XAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

// https://bobbyhadz.com/blog/react-property-does-not-exist-on-type-readonly#:~:text=The%20React.,state%20objects%20of%20the%20class.
class Area_chart extends React.Component {

    data = [
        {
            "name": "Jan 2019",
            "Product A": -5,
            "Procuct B": 5
        },
        {
            "name": "Feb 2019",
            "Product A": 2,
            "Procuct B": 3
        },
        {
            "name": "Mar 2019",
            "Product A": 6,
            "Procuct B": 1
        },
        {
            "name": "Apr 2019",
            "Product A": 0,
            "Procuct B": 3
        },
        {
            "name": "May 2019",
            "Product A": 5,
            "Procuct B": 7
        }
    ];

    render() {
        return (
            <ResponsiveContainer width="90%" aspect={2}>
                <AreaChart data={this.data}
                    margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
                    <defs>
                        <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8} />
                            <stop offset="95%" stopColor="#8884d8" stopOpacity={0} />
                        </linearGradient>
                        <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8} />
                            <stop offset="95%" stopColor="#82ca9d" stopOpacity={0} />
                        </linearGradient>
                    </defs>
                    <XAxis dataKey="name" />
                    <YAxis />
                    <CartesianGrid strokeDasharray="3 3" />
                    <Tooltip />
                    <Legend />
                    <Area type="monotone" dataKey="Product A" stroke="#8884d8" fillOpacity={1} fill="url(#colorUv)" />
                    <Area type="monotone" dataKey="Procuct B" stroke="#82ca9d" fillOpacity={1} fill="url(#colorPv)" />
                </AreaChart>
            </ResponsiveContainer>
        )
    };
}

export default Area_chart;

/*

class Area_chart extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        const initial_data = [
            {
                "name": "Jan 2019",
                "Product A": -5,
                "Procuct B": 5
            },
            {
                "name": "Feb 2019",
                "Product A": 2,
                "Procuct B": 3
            },
            {
                "name": "Mar 2019",
                "Product A": 6,
                "Procuct B": 1
            },
            {
                "name": "Apr 2019",
                "Product A": 0,
                "Procuct B": 3
            },
            {
                "name": "May 2019",
                "Product A": 5,
                "Procuct B": 7
            }
        ];

        this.state = {
            data: initial_data,
        };
    }

    render() {
        return (
            <ResponsiveContainer width="90%" aspect={2}>
                <AreaChart data={this.state.data}
                    margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
                    <defs>
                        <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8} />
                            <stop offset="95%" stopColor="#8884d8" stopOpacity={0} />
                        </linearGradient>
                        <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8} />
                            <stop offset="95%" stopColor="#82ca9d" stopOpacity={0} />
                        </linearGradient>
                    </defs>
                    <XAxis dataKey="name" />
                    <YAxis />
                    <CartesianGrid strokeDasharray="3 3" />
                    <Tooltip />
                    <Legend />
                    <Area type="monotone" dataKey="Product A" stroke="#8884d8" fillOpacity={1} fill="url(#colorUv)" />
                    <Area type="monotone" dataKey="Procuct B" stroke="#82ca9d" fillOpacity={1} fill="url(#colorPv)" />
                </AreaChart>
            </ResponsiveContainer>
        )
    };
}

*/